var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTelegramm = function SvgTelegramm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.602,
    cy: 17,
    r: 17,
    fill: "#9083E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.548 17.318 3.909 1.457 1.523 4.902c.066.332.464.398.729.199l2.186-1.789c.198-.198.53-.198.795 0l3.908 2.849c.265.199.663.066.729-.265L25.24 10.76c.067-.331-.264-.663-.596-.53L8.548 16.457c-.397.132-.397.728 0 .86Zm5.233.729 7.685-4.704c.132-.066.265.133.132.199l-6.293 5.896c-.199.198-.397.463-.397.795l-.2 1.59c0 .198-.33.264-.397 0l-.795-2.915c-.198-.332-.066-.729.265-.861Z",
    fill: "#fff"
  })));
};
export default SvgTelegramm;